module.exports = __webpack_public_path__ + "assets/9a4c14c3102890f123054797cf4f1780.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/last/patagonia/8.jpg
// module id = 797
// module chunks = 0